import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import S3Upload      from 's3_upload';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

const DEFAULT_HEIGHT = 30;
const MAX_HEIGHT = 300;

class MessageInput extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      event      : {},
      media      : '',
      input_mode : '',
    };
  }
  // -------------------------------------------------------
  
  /*
   * スクロール位置調整
   */
  componentDidMount(props) {
    this.changeMessage.bind(this)();
  }
  // -------------------------------------------------------
  
  /*
   * テキストエリアの高さ調整
   */
  changeMessage() {
    try {
      this.message.style.height = DEFAULT_HEIGHT +'px';
      
      let set_height = this.message.scrollHeight
      if( set_height > MAX_HEIGHT ) set_height = MAX_HEIGHT;
      
      this.props.height_ev.bind(this)((set_height - DEFAULT_HEIGHT));
      this.message.style.height = set_height +'px';
      
      // メッセージタイプの設定
      let msg = this.message.value;
      if( msg.replace(/\n|\r/, '').length > 0 ){
        this.setState({ input_mode: 'text' });
        this.props.change_ev.bind(this)({ message_text: msg });
      } else if( this.state.media != '' ){
        this.setState({ input_mode: 'image' });
        this.props.change_ev.bind(this)({ message_media: this.state.media });
      } else {
        this.setState({ input_mode: '' });
        this.props.change_ev.bind(this)({});
      }
    } catch(e) {console.log(e)}
  }
  // -------------------------------------------------------
  
  /*
   * イベント設定
   */
  setEvent(column, ev) {
    let event = this.state.event;
    event[column] = ev;
    this.setState({ event: event });
  }
  // -------------------------------------------------------
  
  /*
   * データ更新時反映
   */
  actionProgress() {
    let media = this.state.event.get_media.bind(this)();
    this.setState({ media: media[(media.length - 1)].url });
    this.changeMessage.bind(this)();
  }
  // -------------------------------------------------------
  
  mediaDelete() {
    this.setState({ media: '' });
    this.props.change_ev.bind(this)({});
  }
  // -------------------------------------------------------
  
  /*
   * ctrl + Enter 送信
   */
  keyAction(e) {
    if( e.ctrlKey && e.keyCode == 13 ) this.props.submit_ev.bind(this)();
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    let event = this.state.event;
    
    return (
      <div className="influencer-contents-message-input">
        <S3Upload setEvent={this.setEvent.bind(this)} actionProgress={this.actionProgress.bind(this)} />
        
        <textarea
          type="text"
          className="text"
          style={{ minHeight: '50px' }}
          onKeyDown={this.keyAction.bind(this)}
          ref={(input) => { this.message = input }}
          onChange={this.changeMessage.bind(this)}
          placeholder="メッセージを入力してください"
        />
        
        { (this.state.input_mode != 'text' && this.state.media == '') &&
          <OverlayTrigger placement="top" delayShow={150} overlay={<Tooltip>画像添付</Tooltip>}>
            <label className="send-media">
              <i className="material-icons">add_a_photo</i>
              <input type="file" name="example" size="30" onChange={(e) => { event.file_upload.bind(this)(e, 'dm/') }} />
            </label>
          </OverlayTrigger>
        }
        
        { (this.state.media != '') &&
          <div className="sample-media">
            { (!Utils.isVideo(this.state.media))
              ? <div className="thumbnail"><img src={this.state.media} onError={(e)=>{e.target.src=this.state.media}} /></div>
              : <div className="thumbnail"><video src={this.state.media} onError={(e)=>{e.target.src=this.state.media}} /></div>
            }
            <div className="delete" onClick={this.mediaDelete.bind(this)}><i className="material-icons">close</i></div>
          </div>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default MessageInput;